<template>
    <div>
        <b-alert :show="!!errorHandlingMessage" variant="danger" dismissible>{{ errorHandlingMessage }}</b-alert>
        <div v-if="hasSubmissions" class="font-weight-bold mb-1">Previous Submissions</div>
        <b-list-group v-if="hasSubmissions" class="shadow-sm">
            <b-list-group-item 
                v-for="sub in submissionList"
                :key="sub.id"
                class="d-flex gap-2 justify-content-between align-items-center"
            >
                <div class="left-side">
                    <div class="font-weight-600 font-size-80">
                        Submitted {{ displayDate(sub.submitted_on) }}
                    </div>
                    <div class="text-muted small">
                        at {{ displayTime(sub.submitted_on) }}
                    </div>
                    <div class="d-flex gap-3 mt-1">
                        <b-badge v-if="sub.id === mostRecentSubmissionId" variant="soft-success" class="font-size-70 text-uppercase">Latest</b-badge>
                        <b-badge v-if="sub.submit_note" v-b-popover.hover.left="sub.submit_note" title="Submission Comments" variant="soft-primary" class="font-size-70 text-uppercase">Comments</b-badge>
                    </div>
                </div>
                <div class="right-side text-center">
                    <b-button :href="sub.excel_download_url" size="sm" variant="gray-secondary">
                        <div class="d-flex align-items-center justify-content-center" style="min-height: 1.5rem; min-width: 1.5rem;">  <!-- put both in a div so size stays consistent when switching -->
                            <span key="excelDownloadLoading" class="fiv-sqo fiv-icon-xlsx font-size-150"></span>
                            <!-- you don't load this via ajax... <b-spinner v-else small></b-spinner> -->
                        </div>
                        <div class="font-size-70 text-uppercase mt-1">
                            Download
                        </div>
                    </b-button>
                </div>
            </b-list-group-item>
        </b-list-group>
    </div>
</template>

<script>
import { suppliosApi } from '../../js/api-service';
import { errorHandling } from '../../js/custom-vue-mixins';
//import { FormatDateTimeLocal } from '../../js/filters-helpers';
import { DateTime } from 'luxon';
import orderBy from 'lodash/orderBy';

export default {
    name: 'PortalRfxResponseSubmissionList',
    components: {},
    mixins: [
        errorHandling,
    ],
    props: {
        responseId: {
            type: String,
            required: true,
        }
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            loading: false,
            submissionList: [],  // from API, not paginated
            mostRecentSubmissionId: '',  // set when processing API response
        }
    },
    computed: {
        hasSubmissions() {
            return this.submissionList.length;
        }
    },
    mounted() {
        this.getList();
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
        refresh() {
            // CALLED FROM PARENT COMPONENTS via refs there
            this.getList();
        },
        async getList() {
            this.loading = true;
            let subList = [];
            try {
                const response = await suppliosApi.rfxResponse.list_submissions(this.responseId);
                subList = response.data;
                // make sure they are sorted correctly - most recent first - so you can highlight the most recent one - outside of try/catch block
            } catch (error) {
                this.apiErrorHandler(error);
            }
            // make sure they're sorted - most recent first - add timestamp based on submitted_on datetime
            const withTimestamp = subList.map(sub => {
                const ts = sub.submitted_on ? DateTime.fromISO(sub.submitted_on).toMillis() : null;
                return {...sub, submitted_on_ts: ts};
            });
            this.submissionList = orderBy(withTimestamp, ['submitted_on_ts'], ['desc']);
            const submissionCount = this.submissionList.length;
            this.mostRecentSubmissionId = submissionCount ? this.submissionList[0].id : '';  // will be the FIRST one in the list
            this.loading = false;
        },
        displayDate(dtString) {
            return dtString ? DateTime.fromISO(dtString).toLocaleString(DateTime.DATE_SHORT) : '';
        },
        displayTime(dtString) {
            return dtString ? DateTime.fromISO(dtString).toLocaleString(DateTime.TIME_SIMPLE) : '';  // will be user's local time
        },
    }
}
</script>

<style>

</style>